import { z } from 'zod'
import { oc } from '@orpc/contract'
import { scribeSourceLanguageSchema } from './encounter-language.contract'

export const activeScribeSessionSchema = z.object({
  sessionId: z.string(),
  encounterId: z.string(),
  patientId: z.string().optional(),
  startedAt: z.string(),
  chunkCount: z.number(),
  lastChunkAt: z.string().optional(),
  status: z.enum(['live', 'finalized']),
  language: scribeSourceLanguageSchema.optional(),
})
export type ActiveScribeSession = z.infer<typeof activeScribeSessionSchema>

export const getActiveScribeSessionResponseSchema = z.object({
  session: activeScribeSessionSchema.nullable(),
})
export type GetActiveScribeSessionResponse = z.infer<typeof getActiveScribeSessionResponseSchema>

export const scribeGetActiveSession = oc
  .route({ method: 'GET', path: '/v2/scribe/sessions/{encounterId}/active' })
  .input(z.object({ encounterId: z.string() }))
  .output(getActiveScribeSessionResponseSchema)
